var generateStyle = function generateStyle(componentTheme) {
  return {
    footerContainer: {
      display: 'flex',
      marginTop: componentTheme.footerContainerMargin
    },
    footerContainerText: {
      flex: '1'
    },
    accessibilityInfo: {
      display: 'flex',
      alignItems: 'center',
      margin: "".concat(componentTheme.accessibilityInfoMargin, " 0 ").concat(componentTheme.accessibilityInfoMargin, " 0")
    },
    accessibilityInfoIcon: {
      marginRight: componentTheme.iconRightMargin
    },
    keyboardControlsList: {
      paddingLeft: componentTheme.keyboardControlsListPadding,
      color: componentTheme.keyboardControlsListColor,
      textDecoration: 'underline',
      cursor: 'pointer'
    },
    modalContent: {
      flex: '1',
      display: 'flex',
      flexDirection: 'column'
    }
  };
};
export default generateStyle;